module.exports = __webpack_public_path__ + "media/images/icons/outlined/to-top-7014dab0a1dbc6a302960508220629d1.svg";